// 강사(CRM 접속권한, memberType === 6) 의 CRM 메뉴 표시 설정에서 다루는 메뉴 정의.
// 단일 소스 — 메뉴 설정 모달 / Navigation 필터 / 라우트 가드가 모두 이 정의를 사용한다.
//
// key   : Navigation 의 menu.name 및 라우트 첫 세그먼트(/key...)와 반드시 동일해야 한다.
// text  : 표시 라벨
// clubFlag : 해당 메뉴를 게이팅하는 클럽 플래그명. 클럽 플래그가 0(OFF)이면 메뉴 자체가 비활성이라
//           설정 모달에서 숨기고(자동 OFF 취급) Navigation/라우트에서도 노출되지 않는다.
export const COACH_MENU_LIST = [
  { key: 'attend', text: '출입기록', clubFlag: 'attendActive' },
  { key: 'locker', text: '락커', clubFlag: null },
  { key: 'lesson', text: '레슨', clubFlag: null },
  { key: 'kiosk', text: '키오스크', clubFlag: 'kiosk' },
  { key: 'mobileProduct', text: '모바일 판매', clubFlag: null },
  { key: 'mobile', text: '광고/홍보', clubFlag: null },
  { key: 'sales', text: '매출', clubFlag: null },
  { key: 'statistics', text: '통계', clubFlag: null },
  { key: 'point', text: '포인트', clubFlag: 'pointActive' },
  { key: 'runningtrack', text: '제타트랙', clubFlag: 'runningTrack' },
  { key: 'prescription', text: '기록 & 처방', clubFlag: null },
  { key: 'coupon', text: '트랩 쿠폰', clubFlag: 'couponFlag' },
  { key: 'configuration', text: '설정', clubFlag: null },
];

export const COACH_MENU_KEYS = COACH_MENU_LIST.map((m) => m.key);

// 클럽 플래그로 비활성(=0)인 메뉴인지 여부 (플래그 없는 메뉴는 항상 활성)
export const isMenuClubDisabled = (menu, club) => {
  if (!menu || !menu.clubFlag) return false;
  if (!club) return false;
  return Number(club[menu.clubFlag]) === 0;
};

// webMenuHidden 문자열('key%&key') → 배열
export const parseHiddenMenus = (webMenuHidden) =>
  webMenuHidden ? String(webMenuHidden).split('%&').filter(Boolean) : [];

// 강사에게 해당 메뉴를 숨겨야 하는지: 클럽 비활성이거나(전체 OFF) 강사 hidden 목록에 포함된 경우.
// hiddenList 는 배열(파싱된 webMenuHidden). 관리 대상이 아닌 메뉴는 차단하지 않는다(false).
export const isMenuHiddenForCoach = (menuKey, club, hiddenList) => {
  const menu = COACH_MENU_LIST.find((m) => m.key === menuKey);
  if (!menu) return false;
  if (isMenuClubDisabled(menu, club)) return true;
  return Array.isArray(hiddenList) && hiddenList.indexOf(menuKey) !== -1;
};
